import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "./reconUtils";

export default function ReconList({ recs, empty, onOpen, testid }) {
  if (!recs.length) return <Card className="p-8 text-center text-sm text-muted-foreground" data-testid={`${testid}-empty`}>{empty}</Card>;
  return (
    <div className="space-y-2" data-testid={testid}>
      {recs.map((r) => {
        const down = r.variances.filter((v) => (v.applied_delta ?? v.variance) < 0).length;
        const up = r.variances.filter((v) => (v.applied_delta ?? v.variance) > 0).length;
        return (
          <Card key={r.id} className="p-3 flex flex-wrap items-center justify-between gap-2" data-testid={`recon-log-${r.id}`}>
            <div className="text-sm min-w-0">
              <div className="flex items-center gap-2"><StatusBadge status={r.status} /><span className="text-muted-foreground">{new Date(r.submitted_at || r.at).toLocaleString("en-ZA")}</span></div>
              <div className="text-xs text-muted-foreground mt-1">
                {r.variances.length} products · <span className="text-emerald-700">{up} up</span> · <span className="text-[#C05746]">{down} down</span> · counted by {r.counted_by_name || r.actor_name}
                {r.approved_by_name && <> · {r.status === "rejected" ? "rejected" : "approved"} by {r.approved_by_name}</>}
              </div>
            </div>
            <Button size="sm" variant="outline" className="rounded-full" onClick={() => onOpen(r.id)} data-testid={`recon-open-${r.id}`}>
              {r.status === "pending" ? "Review" : "View"}
            </Button>
          </Card>
        );
      })}
    </div>
  );
}
